import {
  SEED_FEEDBACK,
  RESET_FB_STATE,
  SET_FB_RES_DATA,
  SET_FB_EDIT_SEEN,
  FEEDBACK_OVERVIEW,
  FEEDBACK_DAILY_RESPONSES,
  FEEDBACK_RATINGS_OVERTIME,
  SET_FB_NEG_ACTION_MSG_SENT,
  SET_NEG_FB_BETA_USERS,
} from "../types";

const initialState = {
  fbResData: {},
  fbSeedData: {},
  isFbSeen: false,
  overview: {},
  dailyResponses: [],
  ratingOverTime: [],
  fbNegMsgSentNum: 0,
  negFbActAccess: false,
};

const feedBackReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NEG_FB_BETA_USERS:
      return {
        ...state,
        negFbActAccess: action.payload,
      };
    case SET_FB_EDIT_SEEN:
      return {
        ...state,
        isFbSeen: action.payload,
      };
    case SET_FB_NEG_ACTION_MSG_SENT:
      return {
        ...state,
        fbNegMsgSentNum: action.payload,
      };
    case SEED_FEEDBACK:
      return {
        ...state,
        fbSeedData: action.payload,
      };
    case SET_FB_RES_DATA:
      return {
        ...state,
        fbResData: action.payload,
      };
    case FEEDBACK_OVERVIEW:
      return {
        ...state,
        overview: action.payload,
      };
    case FEEDBACK_DAILY_RESPONSES:
      return {
        ...state,
        dailyResponses: action.payload,
      };
    case FEEDBACK_RATINGS_OVERTIME:
      return {
        ...state,
        ratingOverTime: action.payload,
      };
    case RESET_FB_STATE:
      return initialState;
    default:
      return state;
  }
};

export default feedBackReducer;
